export default __webpack_public_path__ + "static/media/Rewa-Fort.2461b6e5.jpg";